import { defineRouter } from '#q-app'
import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

import routes from './routes'
import { safeInternalPath, useAccountStore } from '@/stores/account'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter(function () {
  const createHistory = import.meta.env.QUASAR_SERVER
    ? createMemoryHistory
    : import.meta.env.QUASAR_VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(import.meta.env.QUASAR_VUE_ROUTER_BASE),
  })

  Router.beforeEach((to) => {
    if (window.location.hostname === 'yeply-business.web.app') {
      console.log('router beforeEach redirecting to https://business.yeply.com')
      window.location.href = 'https://business.yeply.com'
      return
    }

    if (window.location.hostname === 'business.yeply.com' && to.name !== 'Login') {
      return {
        name: 'Login',
        query: { ...to.query, next: to.fullPath },
        replace: true,
      }
    }

    if (to.query.login_error && to.name !== 'Login') {
      const query = { ...to.query }
      delete query.login_error
      const next = safeInternalPath(Router.resolve({ path: to.path, query, hash: to.hash }).fullPath)
      return {
        name: 'Login',
        query: {
          login_error: to.query.login_error,
          ...(next ? { next } : {}),
        },
      }
    }

    if (to.meta.requiresAuth) {
      const accountStore = useAccountStore()
      accountStore.rememberReturnPath(to.fullPath)
      void accountStore.getMe()
    }
  })

  return Router
})
